import { unsetState } from '~src/state';
import { deleteTmpAnimationObject } from '~video';

export const onCancelAnimation = () => {
  window.canvas.discardActiveObject();
  deleteTmpAnimationObject();
  window.canvas.renderAll();
  unsetState('pendingAnimation');
};
